import { render } from "./Tiyanjin.vue?vue&type=template&id=5081f483&scoped=true"
import script from "./Tiyanjin.vue?vue&type=script&lang=js"
export * from "./Tiyanjin.vue?vue&type=script&lang=js"

import "./Tiyanjin.vue?vue&type=style&index=0&id=5081f483&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5081f483"]])

export default __exports__